import React from 'react';

const weEmulatePeople = {
    weEmulatePeople: {
        heading: 'We emulate people',
        content: [
            <p key="1">
                With our artificial intelligence platform, we create
                virtual experts who efficiently automate and handle manual tasks
                in organisations.
            </p>,
            <p key="2">
                Calcabis’s customised artificial intelligence solution is based
                on cutting edge technologies and always in close collaboration
                with your experts, senior management and IT department. We build
                on your existing IT infrastructure and supply an individually
                adapted version of our platform.
            </p>,
            <p key="3">
                In short, our focus is to help any type of organisation to
                become more efficient on a day-to-day basis, and to be able to
                handle ever more regulatory requirements and increasing societal
                expectations in relation to compliance.
            </p>,
        ],
    },
};

const aboutUs = {
    aboutUs: {
        heading: 'About us',
        content: [
            <p key="1">
                Calcabis has its origins in the Fin- and RegTech environment in
                Copenhagen and consist of a highly experienced team, comprising
                seasoned finance professionals, pioneer developers with more
                than 15 years’ experience in AI and people with international
                experience in the fields of hardware and international business
                development.
            </p>,
            <p key="2">
                In Calcabis, we have come together to utilise artificial
                intelligence to solve the challenges of companies and
                organisations in terms of automating, quality-assuring,
                safeguarding compliance with less resources and supporting
                business-critical manual processes.
            </p>,
            <p key="3">
                At Calcabis, our ambition is to give organisations the optimal
                opportunities and utmost agility in a single, efficient AI
                platform. We have succeeded in this, and today we offer a
                platform that handles a wide range of manual tasks and
                encapsulates and cooperates with human knowledge and
                involvement.
            </p>,
        ],
    },
};

const ourPlatform = {
    platform: {
        heading: 'Our platform',
        content: [
            <p key="1">
                In real time, Calcabis Virtual Expert Platform constantly
                monitors your existing clients and ongoing cases across
                departments, verticals and fields. We integrate and work with
                all data sources, data sets and any human expert knowledge you
                possess. This is the case whether the data is structured or
                unstructured - and no matter which language the data or
                knowledge comes from.
            </p>,
            <p key="2">
                Our virtual experts collect, read, analyse, interpret, conclude
                and describe details from all processes. That means we can
                proactively anticipate relevant trends and increase your chances
                of tracing and documenting fraud and irregularities.
            </p>,
            <p key="3">
                Just as in the real world, our platform always enlists the most
                suitable specialists/virtual experts to solve a specific
                problem. On the basis of the specific database and existing
                knowledge in the organisation, Calcabis’s virtual experts devise
                the optimal process for any given issue.
            </p>,
        ],
    },
};

const ourVirtualExperts = {
    virtualExperts: {
        heading: 'Our virtual experts',
        content: [
            <p key="1">
                By combining multiple AI components, we bridge human knowledge
                and expertise with real AI.
            </p>,
            <p key="2">
                Virtual experts can be customised to all processes and are able
                to manage and automate complex work processes, while at the same
                time supporting manual tasks via an integrated and customised
                neural network of virtual experts. It all happens proactively
                and across time and space, thereby ensuring you always use the
                optimum processes and arrive at the correct conclusions fully
                documented, logged and with full transparency, thereby providing
                you 100% control of the virtual experts and processes.
            </p>,
        ],
    },
    transparent: {
        heading: 'Full transparency',
        content: (
            <p>
                We know the importance of being able to document and report
                issues in order to comply with regulations and legislation. This
                is why we offer a fully transparent platform where all steps,
                data layers and expert knowledge is logged and documented. Based
                on the level of intelligence in the AI, we not only provide the
                correct answer to a given problem, we also explain the reasoning
                behind the conclusion, as well recommend what to do in order to
                solve it most effectively. This gives you a platform that helps
                you with any aspect of your daily work, and makes sure that you
                are always in good and competent hands.
            </p>
        ),
    },
    control: {
        heading: 'Full automation',
        content: (
            <p>
                Calcabis Virtual Expert Platform can fully optimise and automate
                complex work processes. The reason is that our platform works
                consistently and without hindrance until it finds the right
                solution. Full automation may require additional knowledge or
                the setting up of additional virtual experts. On the basis of
                sufficient data and expert knowledge, we can eliminate the need
                for manual resources.
            </p>
        ),
    },
    scalability: {
        heading: 'Control &amp; scalability',
        content: [
            <p key="1">
                When using Calcabis Virtual Expert Platform, changes do not
                require comprehensive, expensive system changes, new codes or
                the like. Our basic principle is that it must be easy to
                maintain your investment in Calcabis and easy to train your
                virtual experts.
            </p>,
            <p key="2">
                For this reason, we have ensured that you will be able to
                develop your virtual experts in the future; for example, when
                new knowledge becomes available in specific areas. Or in case of
                legislation changes. And if knowledge is missing in an area, you
                will be alerted and you can add new knowledge to already
                existing virtual experts, or create an entirely new virtual
                expert for your “expert panel” on an ongoing basis.
            </p>,
            <p key="3">
                This makes our platform a future-proof solution for the
                optimisation of your complex work processes.
            </p>,
        ],
    },
    areas: {
        heading: 'Areas of expertise',
        content: [
            <p key="1">
                We have helped our customers get transparency and control with
                numerous processes such as the below:
            </p>,
            <ul key="2">
                <li>KYC</li>
                <li>AML</li>
                <li>Tax reporting</li>
                <li>GDPR</li>
                <li>Fraud prevention</li>
                <li>Due diligence</li>
                <li>Risk assessment &amp; management</li>
                <li>Data cleansing</li>
                <li>M&amp;A</li>
                <li>Analytics calculations</li>
                <li>Patterns &amp; trends</li>
                <li>Optimisation &amp; predictions</li>
            </ul>,
            <h4 key="3">Our platform can be customized to all processess.</h4>,
        ],
    },
};

export { aboutUs, ourPlatform, ourVirtualExperts, weEmulatePeople };



// WEBPACK FOOTER //
// ./src/components/sections/content/index.js